import { createContext } from 'react'
import { Auth0ClientConfig } from './auth0-client-config'

export default createContext<Auth0ClientConfig>({
  cookieDomain: '',
  consumerUrl: '',
  country: 'Australia',
})
